import FinalCTA from "../../components/layout/FinalCTA";
import OurWorkingAreas from "../../components/layout/OurWorkingAreas";
import PageSEO from "../../components/PageSEO";
import AgentsHero from "./AgentsHero";
import AgentsList from "./AgentsList";

export default function Agents() {
  return (
    <>
      <PageSEO
        title="Our Property Consultants | Vision X Nexus Dubai & Sharjah"
        description="Meet our experienced property consultants specializing in Dubai, Sharjah, and Ajman real estate. Personalized advisory services you can trust."
        canonical="https://visionxnexus.com/agents"
        pageName="Vision X Nexus Property Consultants"
        faqs={[
          {
            question: "Are your agents RERA registered?",
            answer:
              "Our consultants follow UAE real estate regulations and maintain high professional standards.",
          },
          {
            question: "Can agents assist international buyers?",
            answer:
              "Yes, our agents regularly work with international investors and overseas property buyers.",
          },
        ]}
      />
      <AgentsHero />
      <AgentsList />
      <OurWorkingAreas />
      <FinalCTA />
    </>
  );
}
